import { createContext } from 'react';
import type { Region } from 'state/discover/page/page.model';

export interface RegionApi {
  region: Region;
  onRegionChanged(region: Region): void;
  availableRegions: readonly Region[];
}

export const RegionContext = createContext<RegionApi>({
  region: 'Switzerland',
  onRegionChanged() {
    throw new Error('RegionContext not yet initialized.');
  },
  availableRegions: [],
});
